import http from "@/services/http";

/**
 * Anamnese PRESENCIAL (SALVIA-853) — o médico preenche com a paciente na frente
 * dele, durante a consulta.
 *
 * As respostas vão para as MESMAS tabelas `patient_*` das que chegam pelo
 * WhatsApp: o backend roteia por `field_key` no mesmo `ClinicalAnswerRouter`.
 * A diferença é a coluna `source` (`presencial` x `webhook`), que é o que
 * permite ao prontuário dizer se o dado foi informado pela paciente ou
 * registrado pelo médico.
 *
 * As PERGUNTAS vêm de `anamneseTemplateService` — a definição mora na
 * comunicação e cada pergunta já carrega o `fieldKey`.
 */

/**
 * Abre uma anamnese presencial para o paciente.
 * @param {number|string} patientId
 * @param {string} [templateId] template usado (registro; o roteamento é por fieldKey)
 * @returns {Promise<object>} a anamnese criada ({id, session_id, type, ...})
 */
export async function abrirAnamnesePresencial(patientId, templateId) {
  const { data } = await http.post("/api/anamneses/presencial", {
    patient_id: patientId,
    template_id: templateId,
  });
  return data.data;
}

/**
 * Grava UMA resposta. Uma por chamada, como no webhook: se uma pergunta falhar,
 * ela não leva as outras junto.
 *
 * @param {number|string} anamneseId
 * @param {string} fieldKey domínio de destino (ex.: 'medication', 'sleep')
 * @param {{value?: any, data?: object}} resposta
 * @returns {Promise<object>} {field_key, table, action, id}
 */
export async function salvarResposta(anamneseId, fieldKey, resposta = {}) {
  const { data } = await http.post(`/api/anamneses/${anamneseId}/answers`, {
    field_key: fieldKey,
    value: resposta.value ?? null,
    data: resposta.data ?? null,
  });
  return data.data;
}

/**
 * Domínios que já têm dado gravado nesta anamnese — para reabrir de onde parou
 * se a consulta for interrompida.
 * @param {number|string} anamneseId
 * @returns {Promise<string[]>} field_keys já respondidos
 */
export async function respostasJaGravadas(anamneseId) {
  const { data } = await http.get(`/api/anamneses/${anamneseId}/answers`);
  return data.data || [];
}
